/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Tushar Girase",
  title: "Hi all, I'm Tushar",
  subTitle: emoji(
    "Full Stack Java Developer 🚀 with over 11 years of experience in building robust, scalable enterprise web applications using Java, Spring Boot, and modern frontend technologies like React. Adept at designing backend architectures, integrating APIs, and delivering high-performance solutions. Also a Udemy instructor sharing knowledge with the developer community."
  ),
  resumeLink: "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/TusharGirase",
  linkedin: "https://www.linkedin.com/in/tushar-girase-27507869/",
  gmail: "tushargirase1704@gmail.com",
  gitlab: "https://gitlab.com/tushargirase",
  facebook: "https://www.facebook.com/tushar.girase/",
  stackoverflow: "https://stackoverflow.com/users/5319817/tushar-girase",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do?",
  subTitle: "AN ASSISTANT VICE PRESIDENT AT DEUTSCHE BANK",
  skills: [
    emoji("⚡ Design Scalable Java Web Applications"),
    emoji("⚡ Develop and Design Frameworks to support user requirements"),
    emoji("⚡ Improvements and Enhancements in existing applications"),
    emoji("⚡ Devops and CI/CD Implementation")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "spring framework",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "kubernetes",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "gcp",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Indira Institute of Management Pune",
      logo: require("./assets/images/iimpLogo.png"),
      subHeader: "Master of Computer Application",
      duration: "June 2013 - June 2016",
      desc: "Masters with Distinction.",
      descBullets: ["Scored 74.60%"]
    },
    {
      schoolName: "Institute of Management Research and Development",
      logo: require("./assets/images/imrdLogo.png"),
      subHeader: "Bachelor of Computer Application",
      duration: "June 2010 - April 2013",
      desc: "Ranked 6th in University. Passed with distinction.",
      descBullets: ["Scored 83%"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Java", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend/Spring Frameworks",
      progressPercentage: "95%"
    },
    {
      Stack: "System Design",
      progressPercentage: "80%"
    },
    {
      Stack: "Frameworks Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend/React",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Assistant Vice President",
      company: "Deutsche Bank",
      companylogo: require("./assets/images/deutscheLogo.png"),
      date: "March 2024 – Present",
      desc: "With over a decade of experience in backend development, specializing in building high-performance and scalable enterprise-grade applications using Java, Spring Boot, and related technologies.",
      descBullets: [
        "Application deployed in Openshift platform.",
        "Responsible for designing and implementing backend architecture.",
        "Developed CI/CD pipelines using Jenkins.",
        "Mentored and trained junior developers on Java and Spring Boot.",
        "Conducted code reviews and provided constructive feedback to team members.",
        "Participated in code refactoring and performance optimization efforts.",
        "Collaborated with cross-functional teams to deliver high-quality software solutions."
      ]
    },
    {
      role: "Senior Developer",
      company: "Barclays Bank",
      companylogo: require("./assets/images/barclaysLogo.png"),
      date: "Jan 2023 – Mar 2024",
      desc: "Java and Python developer working on Barclays Bank's Next-Gen Banking Platform powered by AWS.",
      descBullets: [
        "Designed and implemented data analytics solutions using AWS Glue and PySpark.",
        "Worked on serverless computing with AWS Lambda.",
        "Event-driven architectures using DynamoDB CDC events.",
        "Hands on experience on wide range of AWS services including Step Functions, Kinesis and CloudWatch."
      ]
    },
    {
      role: "Officer",
      company: "Citi Bank",
      companylogo: require("./assets/images/citiLogo.png"),
      date: "Jun 2021 – Jan 2023",
      desc: "Full Stack Developer at Citi, working in Forex and Local Market risk systems. Responsible for processing risk data, consuming upstream tickets, and integrating with downstream systems.",
      descBullets: [
        "Led requirement grooming, implementation, and framework enhancements.",
        "Tech stack included Spring-based microservices, MongoDB, Apache Kafka, and Hazelcast.",
        "Experienced with CI/CD tools like TeamCity and UDeploy for streamlined deployments."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "PTC",
      companylogo: require("./assets/images/ptcLogo.png"),
      date: "Jul 2015 – Mar 2021",
      desc: "Worked on PTC Windchill MPMLink, a Java EE-based enterprise application",
      descBullets: [
        "Enterprise application work experience.",
        "Developed REST APIs using Apache Olingo for data exchange.",
        "Implemented Spring-based microservices for data processing."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9595303092",
  email_address: "tushargirase1704@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

// Udemy Courses Section
const udemyCoursesSection = {
  title: emoji("Udemy Courses"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  courses: [
    {
      title: "Practical Approach to Spring Cloud Microservices",
      desc: "Spring Boot, Hibernate, WebFlux, OpenFeign, Gateway, Sleuth, Zipkin, Resilience4J, Spring Cloud, Microservices",
      image: require("./assets/images/practicalAppToSpringCloudCourseImage.png"),
      link: "https://www.udemy.com/share/108txy/"
    },
    {
      title: "Spring Security 6 with JWT  and Spring Microservices",
      desc: "Spring Security, Spring Boot, Microservices, JWT, Keycloak",
      image: require("./assets/images/springSecurityCourseImage.png"),
      link: "https://www.udemy.com/course/spring-security-6-with-jwt/?referralCode=B8F62B3B27A4A5D135F6"
    }
  ],

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  udemyCoursesSection
};
